import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ControllerApiPath } from '../services/constant';
import { SharedServiceService } from '../services/shared-service.service';

@Injectable({
  providedIn: 'root'
})
export class TeamService {

  private apiBaseUrl:string;

  constructor(private http: HttpClient,private sharedService: SharedServiceService) {
    this.apiBaseUrl = sharedService.baseUrl();
   }

   getAllCohort(page:any,teamName:string):Observable<any>{    
     let users =  this.getLoggedUser();
    let url ="";
    if(users.role == "Administrator"){
      url = this.apiBaseUrl + ControllerApiPath.teams + '?teamName=' + teamName +'&pageNo='+page+'&pageSize=12';    
    }else{
      url = this.apiBaseUrl + ControllerApiPath.teams + '?teamName=' + teamName +'&loggedInUserId='+users.id+'&pageNo='+page+'&pageSize=12';  
    }
    const headers = this.sharedService.createAuthorizationHeader();    
    return this.http.get(url,{ headers });
  }

    getLoggedUser(){
      return this.sharedService.getLoggedInUser();
    }
}
